import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.open_dialog_view_file,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.open_dialog_view_file) = $event)),
    title: "Visor de archivos",
    "show-close": false,
    class: "bg-fprimary",
    "append-to-body": true,
    fullscreen: ""
  }, {
    header: _withCtx(({ close, titleId, titleClass }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h4", {
          id: titleId,
          class: _normalizeClass([titleClass, "text-white fw-normal"])
        }, _toDisplayString(_ctx.t('fileViewer')), 11, _hoisted_2),
        _createElementVNode("i", {
          onClick: close,
          class: "cursor-pointer bi bi-x-lg fs-4 text-white text-hover-danger"
        }, null, 8, _hoisted_3)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("embed", {
        src: `${_ctx.serverFile}/${_ctx.urlFile}`,
        type: "application/pdf",
        width: "100%",
        height: _ctx.altura<=500 ? '500px' : _ctx.altura+'px'
      }, null, 8, _hoisted_4)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}